import React, { FC } from 'react'
import { useDispatch, useSelector } from '../../store'
import { push } from 'connected-react-router'
import { generatePath, useParams } from 'react-router-dom'
import Step1 from './Step1'
import Step2 from './Step2'

import './CreateAgency.scss'
import { NON_AUTH_ROUTE } from '../App/routes'

interface CreateAgencyProps {}

interface CrateAgencyParams {
  step: string
}

const CreateAgency: FC<CreateAgencyProps> = (props) => {
  const dispatch = useDispatch()
  const inProgress = useSelector((state) => state.agency.inProgress)
  const subInProgress = useSelector((state)=>state.billing.inProgress)
  const { step } = useParams<CrateAgencyParams>()

  const goForward = () => {
    let nextRoute

    if (Number(step) !== 2) {
      nextRoute = generatePath('/create-agency/:step', {
        step: Number(step) + 1
      })
    } else {
      nextRoute = '/create-project/1'
    }
    dispatch(push(nextRoute))
  }

  const skipCreation = () => {
    dispatch(push(NON_AUTH_ROUTE.LOGIN))
  }

  const renderCurrentStep = () => {
    let stepProps = { goForward, skipCreation, inProgress }

    switch (Number(step)) {
      case 1:
        stepProps = {...stepProps,inProgress:(inProgress|| subInProgress)}
        return <Step1 {...stepProps} />
      case 2:
        return <Step2 {...stepProps} />

      default:
        return null
    }
  }

  return renderCurrentStep()
}

export default CreateAgency
